import axios from "axios";
import authHeader from "./AuthHeader";

const editProfile = (data) => {
  return axios.put("/api/admin/edit-profile", data, { headers: authHeader() });
};

const openSubscription = (id, data) => {
  return axios.put(`/api/admin/investments/${id}/open`, data, { headers: authHeader() });
};

const closeSubscription = (id) => {
  return axios.put(`/api/admin/investments/${id}/close`, {}, { headers: authHeader() });
};

const activateInvestmentPlan = (id, data) => {
  return axios.put(`/api/admin/investments/${id}/activate`, data, { headers: authHeader() });
};
const updateRoi = (id, data) => {
  return axios.patch(`/api/admin/investments/${id}/return`, data, { headers: authHeader() });
};

const toggleNotifications = () => {
  return axios.patch('/onboarding/notification/toggle', {}, {
    headers: authHeader(),
  });
};

const markNotificationAsRead = (id) => {
  return axios.patch(`/api/admin/notifications/${id}/read`, {}, {
    headers: authHeader(),
  });
};

const updateRole = (email, role) => {
  return axios.patch(`/api/admin/role`, { email, role }, {
    headers: authHeader(),
  });
};

const reviewAssetFinancingRequest = (requestId, data) => {
  return axios.patch(`/api/admin/asset/requests/${requestId}/review`, data, {
    headers: authHeader(),
  });
};

const updateTaxProfile = (profileId, data) => {
  return axios.put(`/api/admin/tax-profiles/${profileId}`, data, {
    headers: authHeader(),
  });
};

const updateInsuranceProfile = (profileId, data) => {
  return axios.put(`/api/admin/insurance-profiles/${profileId}`, data, {
    headers: authHeader(),
  });
};

const updateAssetProduct = (assetId, data) => {
  return axios.put(`/api/admin/asset/products/${assetId}`, data, {
    headers: authHeader(),
  });
};

const toggleAssetProduct = (assetId) => {
  return axios.patch(`/api/admin/asset/products/${assetId}/toggle`, {}, {
    headers: authHeader(),
  });
};

const rejectAssetRecommendation = (recommendationId, data) => {
  return axios.put(`/api/admin/asset/recommendations/${recommendationId}/reject`, data, {
    headers: authHeader(),
  });
};

const markAssetRequestDelivered = (requestId, data = {}) => {
  return axios.put(`/api/admin/asset/requests/${requestId}/deliver`, data, {
    headers: authHeader(),
  });
};

const putServices = {
  editProfile,
  openSubscription,
  closeSubscription,
  activateInvestmentPlan,
  updateRoi,
  toggleNotifications,
  markNotificationAsRead,
  updateRole,
  reviewAssetFinancingRequest,
  updateTaxProfile,
  updateInsuranceProfile,
  updateAssetProduct,
  toggleAssetProduct,
  rejectAssetRecommendation,
  markAssetRequestDelivered
};

export default putServices;
